/**
 * Architecture feature flags — Strangler Fig migration (Phase 1 audited 2026-06-27).
 *
 * All flags default ON in production. Legacy fallbacks remain in adapter hooks
 * for journey-matrix `feature_flag_respected` tests only — not used in App tick path.
 *
 * Removal target: Wave 6 (see docs/architecture/ADM_MIGRATION_PLAN.md).
 */
export const architectureFeatures = {
  /** UC-01: tick via RunGameTickUseCase + useGameLoop (not setInterval) */
  useCleanArchitectureTick: true,
  /** UC-40/41: save/load via IGameRepository */
  useRepositoryPersistence: true,
  /** UC-10: policy enforcement via EnforcePoliciesUseCase */
  usePolicyUseCases: true,
  /** UC-11/12: create/approve policy via CreatePolicyUseCase / ApprovePolicyUseCase */
  usePolicyMutationUseCases: true,
  /** UC-33: org HR/TPRM/audit tick via UpdateOrgSimulationUseCase */
  useOrgSimulationUseCase: true,
  /** UC-20–22: scenario objectives + milestones via training use cases */
  useTrainingUseCases: true,
  /** Dual-write localStorage + platform API checkpoints */
  usePlatformPersistence: true,
  /** UC-02: build/upgrade/delete via PlaceBuildingUseCase */
  usePlaceBuildingUseCase: true,
  /** UC-05: research progress via AdvanceResearchUseCase */
  useAdvanceResearchUseCase: true,
  /** UC-23: enhanced objectives via EvaluateEnhancedObjectivesUseCase */
  useEnhancedObjectivesUseCase: true,
  /** UC-14: SOC actions via ExecuteSocActionUseCase */
  useSocActionUseCase: true,
  /** UC-04/06: launch product, loans, research start, pitch via economy use cases */
  useEconomyUseCases: true,
  /** UC-24: scripted scenario events via TriggerScriptedEventUseCase */
  useScriptedEventUseCase: true,
  /** UC-25: AI coaching via RequestAiCoachingUseCase + IAiAdvisor */
  useAiCoachingUseCase: true,
  /** UC-30–32: HR/TPRM/audit player actions via org use cases */
  useOrgActionUseCases: true,
  /** UC-13: zone violation checks via CheckZoneViolationsUseCase */
  useZoneViolationUseCase: true,
  /** UC-15: threat aggregation + breach rules via EvaluateThreatUseCase */
  useThreatEvaluationUseCase: true,
  /** Random probabilistic events via TriggerRandomEventUseCase */
  useRandomEventUseCase: true,
  /** UC-35: layer switch via SwitchUndergroundLayerUseCase */
  useLayerSwitchUseCase: true,
  /** UC-42: AI news generation via GenerateAiNewsUseCase */
  useAiNewsUseCase: true,
  /** UC-43: audio via IAudioPort + PlayAudioUseCase */
  useAudioPort: true,
  /** UC-44: tooltip CMS load via LoadTooltipContentUseCase */
  useTooltipContentUseCase: true,
} as const;

export type ArchitectureFeature = keyof typeof architectureFeatures;